export default __webpack_public_path__ + "static/default-theme-d6982a010647627962a35d3822df8d99.svg";